module.exports = __webpack_public_path__ + "img/slide.3bfcc282.jpg";